import { Component, Container } from "../..";
import { CurrencyExchangeInfoTooltipSource } from "./CurrencyExchangeInfoTooltipSource";
import { Layout } from "../../components/layout/Layout";
import { Tooltip } from "./Tooltip";
import { TooltipSourceType } from "./TooltipSourceType";

export class TooltipResolvedContent {
    component: Component;
    includesCurrencyExchangeInfo: boolean;
    type: TooltipSourceType;

    constructor(type: TooltipSourceType, component: Component, tooltip: Tooltip) {
        this.type = type;
        this.component = component;
        this.setIncludesCurrencyExchangeInfo(tooltip);
    }

    private setIncludesCurrencyExchangeInfo(tooltip: Tooltip) {
        if (this.type === TooltipSourceType.CURRENCY_EXCHANGE_INFO) {
            this.includesCurrencyExchangeInfo = true;
            return;
        }
        // If the tooltip doesn't have a currency exchange info source, we don't need to bother looking to see if the
        // resolved content contains the exchange info layout.
        if (tooltip.includesCurrencyExchangeInfo !== true) {
            return;
        }
        if (this.component == null) {
            this.includesCurrencyExchangeInfo = false;
            return;
        }
        if (this.isExchangeInfoLayout(this.component)) {
            this.includesCurrencyExchangeInfo = true;
            return;
        }
        if (this.component instanceof Container) {
            const exchangeInfoLayout = this.component.findComponentById((component: Component) => {
                return this.isExchangeInfoLayout(component);
            });
            this.includesCurrencyExchangeInfo = exchangeInfoLayout != null;
            return;
        }
        this.includesCurrencyExchangeInfo = false;
    }

    private isExchangeInfoLayout(component: Component): boolean {
        return component instanceof Layout &&
            component.layoutName == CurrencyExchangeInfoTooltipSource.EXCHANGE_INFO_LAYOUT_PATH;
    }
}
